var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      clearable: "",
      loading: _vm.branchListLoading,
      name: "branchId",
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.branchId,
      callback: function ($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1)], 1)], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 8,
      lg: 8
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.currentFinancialYearDate.start}&endDate=${_vm.currentFinancialYearDate.end}` + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current FY Sales")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.totalFySales
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 8,
      lg: 8
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.currentFinancialYearDate.start}&endDate=${_vm.currentFinancialYearDate.end}` + (_vm.branchId ? "&branchId=" + _vm.branchId : "")
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current FY Payments")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.totalFyPayment
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 24,
      sm: 8,
      lg: 8
    }
  }, [_c("router-link", {
    attrs: {
      to: `/order/list?startDate=${_vm.currentDateRange.start}&endDate=${_vm.currentDateRange.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Daily Order Value")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.dailyOrderValue
    }
  })], 1)])])], 1)], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.currentMonthDate.start}&endDate=${_vm.currentMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current Month Sale")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.currentMonthSales
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.currentMonthDate.start}&endDate=${_vm.currentMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Current Month Payments")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.currentMonthPayments
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/salesReport/list?startDate=${_vm.previousMonthDate.start}&endDate=${_vm.previousMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Previous Month Sales")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.previousMonthSales
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `report/paymentReport/list?startDate=${_vm.previousMonthDate.start}&endDate=${_vm.previousMonthDate.end}${_vm.branchId ? "&branchId=" + _vm.branchId : ""}`
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Previous Month Payments")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.previousMonthPayments
    }
  })], 1)])])], 1), _c("el-col", {
    staticClass: "card-panel-col",
    attrs: {
      xs: 12,
      sm: 6,
      lg: 6
    }
  }, [_c("router-link", {
    attrs: {
      to: `/report/stock-value${_vm.branchId ? "?branchId=" + _vm.branchId : ""}`
    }
  }, [_c("el-tooltip", {
    attrs: {
      content: "Shows the Total Stock Value",
      placement: "top"
    }
  }, [_c("div", {
    staticClass: "card-panel"
  }, [_c("div", {
    staticClass: "card-panel-description"
  }, [_c("div", {
    staticClass: "card-panel-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c("el-tag", [_vm._v("Total Stock Value")])], 1), _c("inr", {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    },
    attrs: {
      number: _vm.totalStockValue
    }
  })], 1)])])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };